import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "textHeader",
    "imageHeader",
    "body",
    "examples",
    "buttons",
    "buttonTemplate",
    "exampleTemplate",
    "addButton"
  ]

  static values = { maxButtons: { type: Number, default: 10 } }

  connect() {
    this.headerChanged()
    this.syncExamples()
    this.syncAllButtonFields()
    this.updateAddButton()
  }

  headerChanged() {
    const selected = this.element.querySelector("input[name='template[header_type]']:checked")
    const type = selected ? selected.value : "none"

    this.textHeaderTargets.forEach((element) => {
      element.classList.toggle("hidden", type !== "TEXT")
    })
    this.imageHeaderTargets.forEach((element) => {
      element.classList.toggle("hidden", type !== "IMAGE")
    })
  }

  syncExamples() {
    if (!this.hasBodyTarget || !this.hasExamplesTarget || !this.hasExampleTemplateTarget) return

    const matches = [ ...this.bodyTarget.value.matchAll(/\{\{(\d+)\}\}/g) ]
    const count = [ ...new Set(matches.map((match) => match[1])) ].length
    const inputs = [ ...this.examplesTarget.querySelectorAll("input") ]

    while (inputs.length > count) {
      inputs.pop().remove()
    }

    while (this.examplesTarget.querySelectorAll("input").length < count) {
      this.examplesTarget.appendChild(this.exampleTemplateTarget.content.cloneNode(true))
    }

    this.examplesTarget.classList.toggle("hidden", count === 0)
  }

  addButton(event) {
    event.preventDefault()
    if (!this.hasButtonsTarget || !this.hasButtonTemplateTarget) return
    if (this.buttonRows().length >= this.maxButtonsValue) return

    this.buttonsTarget.appendChild(this.buttonTemplateTarget.content.cloneNode(true))
    this.syncAllButtonFields()
    this.updateAddButton()
  }

  removeButton(event) {
    event.preventDefault()
    const row = event.currentTarget.closest("[data-button-row]")
    if (row) row.remove()
    this.updateAddButton()
  }

  buttonTypeChanged(event) {
    this.syncButtonFields(event.currentTarget.closest("[data-button-row]"))
  }

  buttonRows() {
    if (!this.hasButtonsTarget) return []
    return this.buttonsTarget.querySelectorAll("[data-button-row]")
  }

  syncAllButtonFields() {
    this.buttonRows().forEach((row) => this.syncButtonFields(row))
  }

  syncButtonFields(row) {
    if (!row) return

    const type = row.querySelector("[data-button-type]")?.value
    const urlWrap = row.querySelector("[data-button-url-wrap]")
    const phoneWrap = row.querySelector("[data-button-phone-wrap]")
    if (urlWrap) urlWrap.hidden = type !== "URL"
    if (phoneWrap) phoneWrap.hidden = type !== "PHONE_NUMBER"
  }

  updateAddButton() {
    if (!this.hasAddButtonTarget) return
    this.addButtonTarget.disabled = this.buttonRows().length >= this.maxButtonsValue
  }
}
